import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { generateValidation } from 'ecs-react-components/dist/index.es';
import { messages } from './UpdatePasswordPage.i18n';
import { loadPasswordRules } from '../../redux/modules/signup/create-account/create-account-middleware';
import { updatePasswordRequestByUserName } from '../../redux/modules/auth/auth-middleware';
import { getValidations } from '../../containers/Login/UpdatePasswordForm.validations';
import Message from '../../containers/Message/Message';

import UpdatePasswordForm from '../../containers/Login/UpdatePasswordForm';

class UpdatePasswordPage extends Component {
  UNSAFE_componentWillMount = () => {
    this.props.dispatch(loadPasswordRules());
  }

  handleUpdatePassword = (userName, oldPwd, newPwd, confirmNewPwd) => {
    this.props.dispatch(updatePasswordRequestByUserName(userName, oldPwd, newPwd, confirmNewPwd, 'updatepasswordform'));
  }

  render() {
    return (
      <div className="col">
        <Message />
        <div className="row justify-content-md-center mt-3">
          <div className="col-md-8 col-xl-6">
            <div className="card p-3">
              <div className="card-body">
                  <h5 id="content" className="card-title" tabIndex="0">
                    <span className="title" data-qa-item="updatePasswordPageTitle">
                      <FormattedMessage {...messages.page.title} />
                    </span>
                  </h5>
              <div>
                    <UpdatePasswordForm
                      handleUpdatePassword={this.handleUpdatePassword}
                      userName={this.props.userName}
                      pwdRules={this.props.pwdRules}
                      {...generateValidation(getValidations(this.props.pwdRules))}
                    />
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UpdatePasswordPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userName: PropTypes.string,
  pwdRules: PropTypes.object,
};

const mapStateToProps = (state) => ({
  userName: state.profile.auth.userName,
  pwdRules: state.signUp.password,
});

export default connect(mapStateToProps)(UpdatePasswordPage);